var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * 最近聊天tab 数据列表
 */
import React, { useEffect, useState } from 'react';
import { Empty, List } from 'antd';
import UserSelectionContext from '../context';
import TabPaneListItem from './TabPaneListItem';
import { useLoadingProps } from '../hooks';
import { UserSelTab } from '../types';
import { contactAndGroupListItem, getItemChecked, } from '../common';
import SelectAll from './SelectAll';
import Loading from '../../Loading';
export function useGetListItem(_a) {
    var onItemCheck = _a.onItemCheck, result = _a.result, tabKey = _a.tabKey;
    var _b = React.useContext(UserSelectionContext), frozenIds = _b.frozenIds, single = _b.single, defaultUserAvatar = _b.defaultUserAvatar;
    return function (item) {
        var freeze = (frozenIds || []).findIndex(function (a) { return a === item.id; }) >= 0;
        var itemData = __assign(__assign({}, item), { 
            // checked: freeze || result.findIndex((b) => b.id === item.id) >= 0,
            checked: getItemChecked(result, item.id) });
        return (React.createElement(TabPaneListItem, { className: item.groupId || item.gid ? 'groupCanBeSel-item-list' : '', disabled: freeze, defualtImg: defaultUserAvatar, single: single, data: itemData, checkable: true, onCheckChange: function (a) {
                if (onItemCheck) {
                    onItemCheck(a);
                }
            } }));
    };
}
export default function TabPaneList(props) {
    var _this = this;
    var _a = React.useContext(UserSelectionContext), currentUser = _a.currentUser, contactsFilterFlag = _a.contactsFilterFlag, contactShowType = _a.contactShowType, 
    // customTab,
    customTabs = _a.customTabs, 
    // customTab2,
    frozenIds = _a.frozenIds, selectGroupType = _a.selectGroupType;
    var result = props.result, onItemCheck = props.onItemCheck, onGetData = props.onGetData, tabKey = props.tabKey;
    var _b = React.useState(null), dataList = _b[0], setDataList = _b[1];
    var _c = useState(true), loading = _c[0], setLoading = _c[1];
    var _d = useState(null), customRenderer = _d[0], setCustomRenderer = _d[1];
    var _e = useState(false), customCanSelectAll = _e[0], setCustomCanSelectAll = _e[1];
    var loadDataList = React.useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var data, list;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!onGetData) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, onGetData()];
                case 1:
                    data = _a.sent();
                    if (tabKey !== UserSelTab.agentFor) {
                        list = data;
                        if (selectGroupType || contactShowType) {
                            list = contactAndGroupListItem(contactShowType, selectGroupType, data, currentUser);
                        }
                        setDataList(list || []);
                    }
                    else {
                        setDataList(data || []);
                    }
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); }, [contactShowType, currentUser, onGetData, selectGroupType, tabKey]);
    var loadingProps = useLoadingProps(dataList);
    useEffect(function () {
        setCustomRenderer(null);
        setCustomCanSelectAll(false);
        if (customTabs &&
            customTabs.length > 0 &&
            customTabs.findIndex(function (item) { return item.tabName === tabKey; }) > -1) {
            for (var _i = 0, customTabs_1 = customTabs; _i < customTabs_1.length; _i++) {
                var customTab = customTabs_1[_i];
                if (tabKey === customTab.tabName) {
                    if (customTab.canSelectAll) {
                        setCustomCanSelectAll(true);
                    }
                    if (customTab.renderer) {
                        setDataList([]);
                        setCustomRenderer(customTab.renderer());
                    }
                }
            }
        }
        return function () { };
    }, [customTabs, tabKey]);
    useEffect(function () {
        setLoading(true);
        loadDataList();
    }, [loadDataList]);
    var getListItem = useGetListItem({ result: result, onItemCheck: onItemCheck, tabKey: tabKey });
    var comp = React.useMemo(function () {
        if (loading) {
            return React.createElement(Loading, { style: { height: '100%' } });
        }
        if (customRenderer) {
            return customRenderer;
        }
        return (dataList || []).length === 0 ? (React.createElement(Empty, { image: Empty.PRESENTED_IMAGE_SIMPLE, description: "\u6682\u65E0\u6570\u636E" })) : (React.createElement(React.Fragment, null,
            customCanSelectAll && React.createElement(SelectAll, { dataList: dataList || [], result: result }),
            React.createElement(List, { loading: loadingProps, dataSource: dataList || [], renderItem: function (item) { return getListItem(item); } })));
    }, [customCanSelectAll, customRenderer, dataList, getListItem, loading, loadingProps, result]);
    return React.createElement("div", { className: "data-list-container" }, comp);
}
//# sourceMappingURL=TabPaneList.js.map